import { useState } from "react";
import { toast } from "sonner";
import axios from "../axios";

export const useGetTrialCheck = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const getTrialCheck = async (id, token) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `/audiences/spin-the-wheel-participation-details/${id}/trial-check`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setLoading(false);
        setData(res?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return {
    getTrialCheck,
    data,
    setData,
    loading,
    setLoading,
  };
};
